<app-page-header title="Additional Cost Management" subtitle="Manage airline additional cost products and pricing">
    <div actions class="flex items-center gap-3">
        <div class="flex items-center gap-2 mr-2 select-none">
            <label for="archivedSwitch" class="text-sm font-medium"> Show Archived Products </label>
            <p-toggleswitch id="archivedSwitch" [(ngModel)]="showArchived" (onChange)="onToggleArchived($event)" />
        </div>

        <p-button
            label="Export Report"
            (click)="exportXlsxCustom()"
            severity="secondary"
            variant="outlined"
            class="p-button-outlined"
        ></p-button>

        <p-button label="Add New" (click)="openDialog('add')"></p-button>
    </div>
</app-page-header>

<div class="table-card">
    <p-table
        #dt
        [value]="additionalCosts"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [scrollable]="true"
        scrollHeight="flex"
        dataKey="id"
        [rowHover]="true"
        [globalFilterFields]="[
            'airlineCode',
            'name',
            'price.amount',
            'flightType',
            'provider.code',
            'cost.amount',
            'shoppingCategory.name',
            'status',
            'additionalRatio'
        ]"
    >
        <!-- Header -->
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="airlineCode">
                    <div class="flex items-center gap-1 text-left">
                        Airline
                        <p-sortIcon field="airlineCode"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="airlineCode" display="menu"></app-column-filter>
                    </div>
                </th>

                <th pSortableColumn="name">
                    <div class="flex items-center gap-1 text-left">
                        Product Name
                        <p-sortIcon field="name"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="name" display="menu"></app-column-filter>
                    </div>
                </th>

                <th pSortableColumn="price.amount">
                    <div class="flex items-center gap-1 text-left">
                        Price
                        <p-sortIcon field="price.amount"></p-sortIcon>
                        <app-column-filter [table]="dt" type="numeric" field="price.amount" display="menu"></app-column-filter>
                    </div>
                </th>

                <th pSortableColumn="flightType">
                    <div class="flex items-center gap-1 text-left">
                        Flight Type
                        <p-sortIcon field="flightType"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="flightType" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="provider.code">
                    <div class="flex items-center gap-1 text-left">
                        Provider
                        <p-sortIcon field="provider.code"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="provider.code" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="additionalRatio">
                    <div class="flex items-center gap-1 text-left">
                        Additional Ratio
                        <p-sortIcon field="additionalRatio"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="additionalRatio" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="cost.amount">
                    <div class="flex items-center gap-1 text-left">
                        Cost
                        <p-sortIcon field="cost.amount"></p-sortIcon>
                        <app-column-filter [table]="dt" type="numeric" field="cost.amount" display="menu"></app-column-filter>
                    </div>
                </th>

                <th pSortableColumn="shoppingCategory.name">
                    <div class="flex items-center gap-1 text-left">
                        Category
                        <p-sortIcon field="shoppingCategory.name"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="shoppingCategory.name" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="status">
                    <div class="flex items-center gap-1 text-left">
                        Status
                        <p-sortIcon field="status"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="status" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="showOnWeb">
                    <div class="flex items-center gap-1 text-left">
                        Show On Web
                        <p-sortIcon field="showOnWeb"></p-sortIcon>
                    </div>
                </th>

                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-airlineCost>
            <tr>
                <td>{{ airlineCost.airlineCode }}</td>
                <td>{{ airlineCost.name }}</td>
                <td>{{ airlineCost.price?.amount }} {{ airlineCost.price?.currency }}</td>
                <td>{{ airlineCost.flightType }}</td>
                <td>{{ airlineCost.provider?.code }}</td>
                <td>{{ airlineCost.additionalRatio }}</td>
                <td>{{ airlineCost.cost?.amount }} {{ airlineCost.cost?.currency }}</td>
                <td>{{ airlineCost.shoppingCategory?.name }}</td>
                <td>{{ airlineCost.status }}</td>
                <td>
                    <p-toggleswitch
                        [(ngModel)]="airlineCost.showOnWeb"
                        (onChange)="onToggleShowOnWeb(airlineCost)"
                        [disabled]="showArchived"
                    />
                </td>
                <td>
                    <p-button link type="button" icon="pi pi-ellipsis-h" class="p-button-text" (click)="op.toggle($event)"></p-button>
                    <p-popover #op>
                        <ul class="list-none p-2 m-0">
                            <li
                                class="cursor-pointer p-2 hover:bg-gray-100"
                                *ngIf="!showArchived"
                                (click)="openDialog('edit', airlineCost)"
                            >
                                Edit
                            </li>
                            <li class="cursor-pointer p-2 hover:bg-gray-100" *ngIf="!showArchived" (click)="archive(airlineCost.id)">
                                Send to archive
                            </li>
                            <li class="cursor-pointer p-2 hover:bg-gray-100" (click)="showHistory(airlineCost)">Show history</li>
                        </ul>
                    </p-popover>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <p-dialog
        [(visible)]="displayDialog"
        [modal]="true"
        (onHide)="hideDialog(frm)"
        [header]="dialogHeader"
        [closable]="true"
        [style]="{ width: '400px' }"
    >
        <form #frm="ngForm" novalidate>
            <div class="p-fluid">
                <!-- Category -->
                <div class="p-field mb-2">
                    <p-select
                        name="categoryId"
                        [(ngModel)]="formData.categoryId"
                        [options]="categories"
                        optionLabel="name"
                        optionValue="id"
                        required
                        appendTo="body"
                        class="flex-auto w-full"
                        placeholder="Select Category"
                        (onChange)="onCategoryChange($event.value)"
                        #catCtrl="ngModel"
                    >
                    </p-select>
                    <small *ngIf="catCtrl.invalid && (catCtrl.touched || frm.submitted)" class="ml-2 text-red-500">
                        Category is required
                    </small>
                </div>

                <!-- Product -->
                <div class="p-field mb-2">
                    <p-select
                        name="productId"
                        [(ngModel)]="formData.productId"
                        [options]="productsForSelectedCategory"
                        optionLabel="name"
                        optionValue="id"
                        required
                        appendTo="body"
                        class="flex-auto w-full"
                        placeholder="Select Product"
                        #prodCtrl="ngModel"
                    >
                    </p-select>
                    <small *ngIf="prodCtrl.invalid && (prodCtrl.touched || frm.submitted)" class="ml-2 text-red-500">
                        Product is required
                    </small>
                </div>

                <!-- Airline -->
                <div class="p-field mb-2">
                    <p-select
                        name="airlineCode"
                        [(ngModel)]="formData.airlineCode"
                        [options]="airlines"
                        [required]="isAirlineRequired"
                        [disabled]="isAirlineDisabled"
                        appendTo="body"
                        showClear="true"
                        class="flex-auto w-full"
                        placeholder="Select Airline"
                        #airCtrl="ngModel"
                    >
                    </p-select>
                    <small *ngIf="airCtrl.invalid && (airCtrl.touched || frm.submitted)" class="ml-2 text-red-500">
                        Airline is required
                    </small>
                </div>

                <!-- Flight Type -->
                <div class="p-field mb-2">
                    <p-select
                        name="flightType"
                        [(ngModel)]="formData.flightType"
                        [options]="flightTypes"
                        showClear="true"
                        [required]="isFlightTypeRequired"
                        [disabled]="isFlightTypeDisabled"
                        appendTo="body"
                        class="flex-auto w-full"
                        placeholder="Select Flight Type"
                        #ftCtrl="ngModel"
                    >
                    </p-select>
                    <small *ngIf="ftCtrl.invalid && (ftCtrl.touched || frm.submitted)" class="ml-2 text-red-500">
                        Flight type is required
                    </small>
                </div>

                <!-- Provider -->
                <div class="p-field mb-2">
                    <p-select
                        name="providerId"
                        [(ngModel)]="formData.providerId"
                        [options]="providers"
                        optionLabel="code"
                        optionValue="id"
                        showClear="true"
                        [required]="isProviderRequired"
                        [disabled]="isProviderDisabled"
                        appendTo="body"
                        class="flex-auto w-full"
                        placeholder="Select Provider"
                        #prCtrl="ngModel"
                    >
                    </p-select>
                    <small *ngIf="prCtrl.invalid && (prCtrl.touched || frm.submitted)" class="ml-2 text-red-500">
                        Provider is required
                    </small>
                </div>

                <!-- Additional Ratio -->
                <div class="p-field mb-2">
                    <input
                        name="ratio"
                        [required]="isAdditionalRatioRequired"
                        [disabled]="isAdditionalRatioDisabled"
                        [(ngModel)]="formData.additionalRatio"
                        type="number"
                        required
                        min="0"
                        class="flex-auto w-full"
                        pInputText
                        placeholder="Additional Ratio"
                        #ratioCtrl="ngModel"
                    />
                    <small *ngIf="ratioCtrl.invalid && (ratioCtrl.touched || frm.submitted)" class="ml-2 text-red-500">
                        Additional Ratio is required
                    </small>
                </div>

                <!-- Price -->
                <div class="p-field mb-2">
                    <input
                        name="priceAmount"
                        [(ngModel)]="formData.priceAmount"
                        type="number"
                        required
                        min="0"
                        class="flex-auto w-full"
                        pInputText
                        placeholder="Price (amount)"
                        #priceCtrl="ngModel"
                    />
                    <small *ngIf="priceCtrl.invalid && (priceCtrl.touched || frm.submitted)" class="ml-2 text-red-500">
                        Price is required
                    </small>
                </div>

                <!-- Cost -->
                <div class="p-field mb-2">
                    <input
                        name="costAmount"
                        [(ngModel)]="formData.costAmount"
                        type="number"
                        required
                        min="0"
                        class="flex-auto w-full"
                        pInputText
                        placeholder="Cost (amount)"
                        #costCtrl="ngModel"
                    />
                    <small *ngIf="costCtrl.invalid && (costCtrl.touched || frm.submitted)" class="ml-2 text-red-500">
                        Cost is required
                    </small>
                </div>

                <!-- Show On Web -->
                <div class="p-field mb-2 flex items-center gap-2">
                    <label for="showOnWebSwitch" class="text-sm font-medium">Show On Web</label>
                    <p-toggleswitch id="showOnWebSwitch" name="showOnWeb" [(ngModel)]="formData.showOnWeb" />
                </div>
            </div>
        </form>

        <ng-template pTemplate="footer">
            <div class="flex justify-between w-full">
                <p-button label="Cancel" [text]="true" severity="secondary" (click)="hideDialog(frm)"></p-button>
                <p-button [label]="dialogMode === 'add' ? 'Add New' : 'Save'" (click)="save(frm)"></p-button>
            </div>
        </ng-template>
    </p-dialog>

    <!-- Confirmation Dialog -->
    <p-confirmdialog></p-confirmdialog>

    <!-- Dialog for history -->
    <p-dialog [(visible)]="displayHistoryDialog" [modal]="true" [header]="'Show History'" [closable]="true">
        <div class="p-fluid">
            <p-table [rows]="10" [paginator]="true" [value]="historyData" [scrollable]="true" scrollHeight="flex">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="updateDateTime">
                            <div class="flex items-center gap-2 text-left">
                                Updated Date/Time
                                <p-sortIcon field="updateDateTime" />
                                <app-column-filter [table]="dt" type="text" field="updateDateTime" display="menu"></app-column-filter>
                            </div>
                        </th>
                        <th pSortableColumn="updatedBy">
                            <div class="flex items-center gap-2 text-left">
                                Updated By
                                <p-sortIcon field="updatedBy" />
                                <app-column-filter [table]="dt" type="text" field="updatedBy" display="menu"></app-column-filter>
                            </div>
                        </th>
                        <th pSortableColumn="airline">
                            <div class="flex items-center gap-2 text-left">
                                Airline
                                <p-sortIcon field="airline" />
                                <app-column-filter [table]="dt" type="text" field="airline" display="menu"></app-column-filter>
                            </div>
                        </th>
                        <th pSortableColumn="productName">
                            <div class="flex items-center gap-2 text-left">
                                Product Name
                                <p-sortIcon field="productName" />
                                <app-column-filter [table]="dt" type="text" field="productName" display="menu"></app-column-filter>
                            </div>
                        </th>
                        <th pSortableColumn="price">
                            <div class="flex items-center gap-2 text-left">
                                Price
                                <p-sortIcon field="price" />
                                <app-column-filter [table]="dt" type="text" field="price" display="menu"></app-column-filter>
                            </div>
                        </th>
                        <th pSortableColumn="flightType">
                            <div class="flex items-center gap-2 text-left">
                                Flight Type
                                <p-sortIcon field="flightType" />
                                <app-column-filter [table]="dt" type="text" field="flightType" display="menu"></app-column-filter>
                            </div>
                        </th>
                        <th pSortableColumn="cost">
                            <div class="flex items-center gap-2 text-left">
                                Cost
                                <p-sortIcon field="cost" />
                                <app-column-filter [table]="dt" type="text" field="cost" display="menu"></app-column-filter>
                            </div>
                        </th>
                        <th pSortableColumn="category">
                            <div class="flex items-center gap-2 text-left">
                                Category
                                <p-sortIcon field="category" />
                                <app-column-filter [table]="dt" type="text" field="category" display="menu"></app-column-filter>
                            </div>
                        </th>
                        <th pSortableColumn="status">
                            <div class="flex items-center gap-2 text-left">
                                Status
                                <p-sortIcon field="status" />
                                <app-column-filter [table]="dt" type="text" field="status" display="menu"></app-column-filter>
                            </div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-history>
                    <tr>
                        <td>{{ history.updatedTime | date: 'yyyy-MM-dd HH:mm' }}</td>
                        <td>{{ history.updatedBy }}</td>
                        <td>{{ history.airlineCode }}</td>
                        <td>{{ history.productName }}</td>
                        <td>{{ history.price.amount }} {{ history.price.currency }}</td>
                        <td>{{ history.flightType }}</td>
                        <td>{{ history.cost.amount }} {{ history.cost.currency }}</td>
                        <td>{{ history.categoryName }}</td>
                        <td>{{ history.status }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <ng-template pTemplate="footer">
            <div class="flex justify-end">
                <p-button label="Close" (click)="hideDialogHistory()" severity="secondary"></p-button>
            </div>
        </ng-template>
    </p-dialog>
</div>
